<template>
	<div style="padding-bottom: 80px;">
		<van-nav-bar class="nav-bar newnavbar" :title="$t('xqaltit')">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="casesList">
			<div class="casesItem" v-for="(v, i) in datalist" :key="i" @click="toDetail(v.id)">
				<div class="casesTop">
					<div>
						<van-image :src="v.imgUrl" :height="150" width="100%" fit="cover">
							<template v-slot:loading>
								<van-loading type="spinner" size="20" />
							</template>
							<template v-slot:error><van-image src="/img/error.png" /></template>
						</van-image>
					</div>
					<div :class="{ active: v.gender == 1 }">{{ v.age }} / {{ v.gender == 1 ? $t('male') : $t('female')
						}}
					</div>
				</div>
				<div class="casesBtm">
					<div>
						<van-icon name="location" color="#333" size="18" />
						<span class="van-ellipsis">{{ v.address }}</span>
					</div>
					<div>
						<van-icon name="label" color="#333" size="18" />
						<span class="van-ellipsis">{{ v.title }}</span>
					</div>
				</div>
			</div>
		</div>
		<van-empty v-if="datalist && datalist.length == 0" image-size="50px"
			style="width: 100%; padding-top: 90px; color: #000;" image="/img/emptyData.png"
			:description="$t('emptyData')" />
	</div>
</template>

<script>
import releaseItem from '@/common/releaseItem.vue'
import horizontalItem from '@/common/horizontalItem.vue'
export default {
	components: {
		releaseItem,
		horizontalItem
	},
	data() {
		return {
			datalist: [],
		};
	},
	created() {
		this.$http({
			method: 'get',
			url: 'getCaseList',
			data: {}
		}).then(res => {
			console.log("getCaseList", res);
			(res.data || []).map(v => {
				v.imgUrl = this.$config.baseURL + v.imgurl;
			})
			this.datalist = res.data || [];
		});
	},
	methods: {
		toDetail(id) {
			this.$router.push({
				path: '/caseDetail?id=' + id
			});
		},
		back() {
			this.$router.go(-1);
		},
	},
};
</script>

<style lang="less" scoped>
@notice-bar-size: 30px;

.newnavbar {
	height: 100px;
	background: #1989fa;
}

.van-nav-bar {
	line-height: 50px;
}

::v-deep .van-nav-bar__title {
	max-width: 60%;
	margin: 0 auto;
	color: #ffffff;
	font-size: 35px;
}

::v-deep .van-nav-bar__content {
	height: 100px;
}

.casesList {
	padding: 15px;
	height: calc(100vh - 260px);
	overflow: auto;

	.casesItem {
		margin-bottom: 15px;
		border-radius: 10px;
		overflow: hidden;
		box-shadow: 0 0 4px 0 rgba(0, 0, 0, .32);

		.casesTop {
			position: relative;

			>div:last-child {
				position: absolute;
				bottom: 10px;
				left: 10px;
				color: #fff;
				background: #d96c62;
				border-radius: 30px;
				padding: 5px 15px;
				font-size: 15px;
				font-weight: bold;
			}

			>div.active {
				background: #6696d9;
			}
		}

		.casesBtm {
			>div {
				padding: 10px;
				font-size: 15px;
				color: #333;
				display: flex;
				align-items: center;
			}

			>div:last-child {
				background: #f5f5f5;
			}
		}
	}
}
</style>